$(document).ready(function() {
  // Get the URL parameters
  var params = new URLSearchParams(window.location.search);

  // Define the UTM names and the corresponding value conditions
  var utmValueConditions = {
    'score_overall': '<130',
    'metric_cod': '>34.99',
    'metric_opex': '>29.99',
    'metric_ccc': '>20',
    'metric_ltv-percent-60': '<25',
    'metric_ltv-percent-year': '<90',
    'metric_fov-ncac': '<=0',
    'metric_distchannel': '<3',
    'metric_orgtraffic': '<50',
    'metric_ltv-ncac-year': '<0.45',
    'metric_revpeaks': '<4'
  };
    
  // Format UTM Date (MM-DD-YYYY)
  function utmDateFormat(dateString) {
    if (utmDate) {
      const date = new Date(dateString);
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
      const year = date.getFullYear();
      return `${month}-${day}-${year}`;
    } else {
      const date = new Date();
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
      const year = date.getFullYear();
      return `${month}-${day}-${year}`;
    }
  }
    
  // Declare UTM values and variables
  const businessName = params.get("name");
  const utmDate = params.get("date");
  const fileNameDate = utmDateFormat(utmDate);
  const fileNameBusiness = businessName.replace(/ /g, '_');

  // Loop through the dynamic elements and update their text
  $('.dynamic').each(function() {
    var paramName = $(this).data('id');
    if (paramName && paramName.startsWith('metric_') && params.has(paramName)) {
      var paramValue = params.get(paramName);
      var operator = utmValueConditions[paramName];
      if (operator) {
        var expression = paramValue + operator;
        if (eval(expression)) {
          $(this).removeClass('hide').addClass('true');
        }
      }
    } else if (paramName && params.has(paramName)) {
      var paramValue = params.get(paramName);
      var operator = utmValueConditions[paramName];
      if (operator) {
        var expression = paramValue + operator;
        if (eval(expression)) {
          $(this).children('.dynamic').toggleClass('hide');
        }
      }
    }
  });

  // Hide all dynamic elements that still have the hide class
  $('#dynamic-suggestions .dynamic.hide').remove();

  // Loop through the dynamic elements and update their text
  $('.dynamic.value').each(function() {
    var paramName = $(this).data('id');
    if (paramName && params.has(paramName)) {
      var paramValue = params.get(paramName).replace(/"/g, ''); // remove quotes
      paramValue = decodeURIComponent(paramValue).replace(/&/g, '&amp;'); // encode ampersand
      $(this).removeClass('hide').addClass('true').html(paramValue);
    }
  });

  // PDF Lib
  const { degrees, PDFDocument, rgb, PDFFont } = PDFLib;

  async function modifyPdf() {
    
    // Fetch an existing PDF document
    let url1 = "https://5507026.fs1.hubspotusercontent-na1.net/hubfs/5507026/Diagnostic_Results_First_PDF_130_Blank.pdf";
    
    // Check the condition for 'score_overall'
    const scoreOverall = parseFloat(params.get('score_overall'));
    if (!isNaN(scoreOverall) && scoreOverall < 130) {
      // Change the URL if the condition is met
      url1 = "https://5507026.fs1.hubspotusercontent-na1.net/hubfs/5507026/Diagnostic_Results_First_PDF_Blank.pdf";
    }
    
    const firstPdfBytes = await fetch(url1).then((res) => res.arrayBuffer());
    
    const urlCOD = "https://5507026.fs1.hubspotusercontent-na1.net/hubfs/5507026/Diagnostic_Results_COD_Blank.pdf"
    const codPdfBytes = await fetch(urlCOD).then((res) => res.arrayBuffer())
    const urlOPEX = "https://5507026.fs1.hubspotusercontent-na1.net/hubfs/5507026/Diagnostic_Results_OPEX_Blank.pdf"
    const opexPdfBytes = await fetch(urlOPEX).then((res) => res.arrayBuffer())
    const urlCCC = "https://5507026.fs1.hubspotusercontent-na1.net/hubfs/5507026/Diagnostic_Results_CCC_Blank.pdf"
    const cccPdfBytes = await fetch(urlCCC).then((res) => res.arrayBuffer())
    const urlRev60 = "https://5507026.fs1.hubspotusercontent-na1.net/hubfs/5507026/Diagnostic_Results_Rev_60_Blank.pdf"
    const rev60PdfBytes = await fetch(urlRev60).then((res) => res.arrayBuffer())
    const urlRevYear = "https://5507026.fs1.hubspotusercontent-na1.net/hubfs/5507026/Diagnostic_Results_Rev_Year_Blank.pdf"
    const revYearPdfBytes = await fetch(urlRevYear).then((res) => res.arrayBuffer())  
    const urlFOVnCAC = "https://5507026.fs1.hubspotusercontent-na1.net/hubfs/5507026/Diagnostic_Results_FOVnCAC_Blank.pdf"
    const fovnCACPdfBytes = await fetch(urlFOVnCAC).then((res) => res.arrayBuffer())
    const urlDistChannels = "https://5507026.fs1.hubspotusercontent-na1.net/hubfs/5507026/Diagnostic_Results_Distribution_Channels_Blank.pdf"
    const distChannelsPdfBytes = await fetch(urlDistChannels).then((res) => res.arrayBuffer())
    const urlOrgTraffic = "https://5507026.fs1.hubspotusercontent-na1.net/hubfs/5507026/Diagnostic_Results_Org_Traffic_Blank.pdf"
    const orgTrafficPdfBytes = await fetch(urlOrgTraffic).then((res) => res.arrayBuffer())
    const urlYearLTV = "https://5507026.fs1.hubspotusercontent-na1.net/hubfs/5507026/Diagnostic_Results_One_Year_LTV_Blank.pdf"
    const yearLTVPdfBytes = await fetch(urlYearLTV).then((res) => res.arrayBuffer())
    const urlRevPeaks = "https://5507026.fs1.hubspotusercontent-na1.net/hubfs/5507026/Diagnostic_Results_Rev_Peaks_Blank.pdf"
    const revPeaksPdfBytes = await fetch(urlRevPeaks).then((res) => res.arrayBuffer())

    const urlFinal = "https://5507026.fs1.hubspotusercontent-na1.net/hubfs/5507026/Diagnostic_Results_Final_PDF_Blank.pdf"
    const finalPdfBytes = await fetch(urlFinal).then((res) => res.arrayBuffer())
    
    // Stitching Pages Declarations
    const firstPdf = await PDFDocument.load(firstPdfBytes)
    const codPdf = await PDFDocument.load(codPdfBytes)
    const opexPdf = await PDFDocument.load(opexPdfBytes)
    const cccPdf = await PDFDocument.load(cccPdfBytes)
    const rev60Pdf = await PDFDocument.load(rev60PdfBytes)
    const revYearPdf = await PDFDocument.load(revYearPdfBytes)
    const fovnCACPdf = await PDFDocument.load(fovnCACPdfBytes)
    const distChannelsPdf = await PDFDocument.load(distChannelsPdfBytes)
    const orgTrafficPdf = await PDFDocument.load(orgTrafficPdfBytes)
    const yearLTVPdf = await PDFDocument.load(yearLTVPdfBytes)
    const revPeaksPdf = await PDFDocument.load(revPeaksPdfBytes)
    const finalPdf = await PDFDocument.load(finalPdfBytes)

    // Fetch custom font
    const boldUrl = "https://5507026.fs1.hubspotusercontent-na1.net/hubfs/5507026/Poppins-Bold.ttf"
    const regularUrl = "https://5507026.fs1.hubspotusercontent-na1.net/hubfs/5507026/Poppins-Regular.ttf"
    const oswaldUrl = "https://5507026.fs1.hubspotusercontent-na1.net/hubfs/5507026/Oswald-Regular.ttf"
    const boldBytes = await fetch(boldUrl).then(res => res.arrayBuffer())
    const regularBytes = await fetch(regularUrl).then(res => res.arrayBuffer())
    const oswaldBytes = await fetch(oswaldUrl).then(res => res.arrayBuffer())
    

    // Load a PDFDocument from the existing PDF bytes and stitch with other PDFs
    const pdfDoc = await PDFDocument.create();

    const [coverPage] = await pdfDoc.copyPages(firstPdf, [0])
    const [resultsPage] = await pdfDoc.copyPages(firstPdf, [1])
    const [issuesCover] = await pdfDoc.copyPages(firstPdf, [2])
    const [codPage] = await pdfDoc.copyPages(codPdf, [0])
    const [codPage2] = await pdfDoc.copyPages(codPdf, [1])
    const [codPage3] = await pdfDoc.copyPages(codPdf, [2])
    const [opexPage] = await pdfDoc.copyPages(opexPdf, [0])
    const [cccPage] = await pdfDoc.copyPages(cccPdf, [0])
    const [rev60Page] = await pdfDoc.copyPages(rev60Pdf, [0])
    const [revYearPage] = await pdfDoc.copyPages(revYearPdf, [0])
    const [fovnCACPage] = await pdfDoc.copyPages(fovnCACPdf, [0])
    const [fovnCACPage2] = await pdfDoc.copyPages(fovnCACPdf, [1])
    const [distChannelsPage] = await pdfDoc.copyPages(distChannelsPdf, [0])
    const [orgTrafficPage] = await pdfDoc.copyPages(orgTrafficPdf, [0])
    const [orgTrafficPage2] = await pdfDoc.copyPages(orgTrafficPdf, [1])
    const [yearLTVPage] = await pdfDoc.copyPages(yearLTVPdf, [0])
    const [revPeaksPage] = await pdfDoc.copyPages(revPeaksPdf, [0])
    const [finalPage] = await pdfDoc.copyPages(finalPdf, [0])

    // Static Page Inserts
    pdfDoc.addPage(coverPage)
    pdfDoc.addPage(resultsPage)
    pdfDoc.addPage(issuesCover)

    // Dynamic Page Mapping
    var metricToPageMap = {
      'metric_cod': [codPage, codPage2, codPage3],
      'metric_opex': [opexPage],
      'metric_ccc': [cccPage],
      'metric_ltv-percent-60': [rev60Page],
      'metric_ltv-percent-year': [revYearPage],
      'metric_fov-ncac': [fovnCACPage, fovnCACPage2],
      'metric_distchannel': [distChannelsPage],
      'metric_orgtraffic': [orgTrafficPage, orgTrafficPage2],
      'metric_ltv-ncac-year': [yearLTVPage],
      'metric_revpeaks': [revPeaksPage]
    };
    
    // Loop through dynamic pages and insert them if they meet our conditions
    Object.entries(metricToPageMap).forEach(async ([metricName, pagesToInsertArray]) => {
      if (params.has(metricName)) {
        const paramValue = params.get(metricName);
        const operator = utmValueConditions[metricName];
        if (operator) {
          const expression = paramValue + operator;
          if (eval(expression)) {
            for (const page of pagesToInsertArray) {
              pdfDoc.addPage(page); // Add each page in the array
            }
          }
        }
      }
    });

    // Static Page Insert
    pdfDoc.addPage(finalPage)

    // Fontkit
    pdfDoc.registerFontkit(fontkit)
    
    // Embed the fonts
    const poppinsB = await pdfDoc.embedFont(boldBytes)
    const poppinsR = await pdfDoc.embedFont(regularBytes)
    const oswaldR = await pdfDoc.embedFont(oswaldBytes)

    // Format date
    function pdfDate(dateString) {
      const months = ['Jan.', 'Feb.', 'Mar.', 'Apr.', 'May', 'Jun.', 'Jul.', 'Aug.', 'Sep.', 'Oct.', 'Nov.', 'Dec.'];
      
      if (utmDate) {
        const dateParts = utmDate.split("/");
        const monthIndex = parseInt(dateParts[0]) - 1;
        const dayIndex = parseInt(dateParts[1]);
        const yearIndex = parseInt(dateParts[2]);
        return `${months[monthIndex]} ${dayIndex}, ${yearIndex}`;
      } else {
        const today = new Date();
        const monthIndex = months[today.getMonth()];
        const dayIndex = today.getDate();
        const yearIndex = today.getFullYear();
        return `${monthIndex} ${dayIndex}, ${yearIndex}`;
      }
    }
        
    // Get the variables for drawn text
    const pages = pdfDoc.getPages();
    const firstPage = pages[0];
    const secondPage = pages[1];
    const formattedDate = pdfDate();
    const textSize = 8;
    const font = poppinsR;
    const scoreWidth = 72;
    const gqWidth = 45;

    // Draw dynamic text on the first page
    firstPage.drawText(`${params.get("name")}\u2019s Diagnostic Report`, { size: 42, lineHeight: 44, x: 32, y: 435, font: poppinsB, color: rgb(1, 1, 1), maxWidth: 560 });
    firstPage.drawText(formattedDate, { size: 16, lineHeight: 19, x: 32, y: 308, font: font, color: rgb(0.85, 1, 0.2) });
    firstPage.drawText(`${params.get("score_overall")}`, { size: 16, lineHeight: 19, x: 167, y: 286, font: font, color: rgb(0.85, 1, 0.2) });
    
    // Draw dyanmic text on the second page
    secondPage.drawText(`${params.get("score_overall")}`, { size: 12, x: 255, y: 510, font: poppinsB });
    secondPage.drawText(`${params.get("metric_cod")}%`, { size: textSize, x: 296.5 + (scoreWidth - font.widthOfTextAtSize(`${params.get("metric_cod")}%`, textSize)) * .5, y: 353, font: font });
    secondPage.drawText(`${params.get("score_cod")}`, { size: textSize, x: 512 + gqWidth - font.widthOfTextAtSize(`${params.get("score_cod")}`, textSize), y: 353, font: font });
    secondPage.drawText(`${params.get("metric_opex")}%`, { size: textSize, x: 296.5 + (scoreWidth - font.widthOfTextAtSize(`${params.get("metric_opex")}%`, textSize)) * .5, y: 331, font: font });
    secondPage.drawText(`${params.get("score_opex")}`, { size: textSize, x: 512 + gqWidth - font.widthOfTextAtSize(`${params.get("score_opex")}`, textSize), y: 331, font: font });
    secondPage.drawText(`${params.get("metric_ccc")}`, { size: textSize, x: 296.5 + (scoreWidth - font.widthOfTextAtSize(`${params.get("metric_cccc")}`, textSize)) * .5, y: 309, font: font });
    secondPage.drawText(`${params.get("score_ccc")}`, { size: textSize, x: 512 + gqWidth - font.widthOfTextAtSize(`${params.get("score_ccc")}`, textSize), y: 309, font: font });
    secondPage.drawText(`${params.get("metric_ltv-percent-60")}%`, { size: textSize, x: 296.5 + (scoreWidth - font.widthOfTextAtSize(`${params.get("metric_ltv-percent-60")}%`, textSize)) * .5, y: 287, font: font });
    secondPage.drawText(`${params.get("score_ltv-percent-60")}`, { size: textSize, x: 512 + gqWidth - font.widthOfTextAtSize(`${params.get("score_ltv-percent-60")}`, textSize), y: 287, font: font });
    secondPage.drawText(`${params.get("metric_ltv-percent-year")}%`, { size: textSize, x: 296.5 + (scoreWidth - font.widthOfTextAtSize(`${params.get("metric_ltv-percent-year")}%`, textSize)) * .5, y: 265, font: font });
    secondPage.drawText(`${params.get("score_ltv-percent-year")}`, { size: textSize, x: 512 + gqWidth - font.widthOfTextAtSize(`${params.get("score_ltv-percent-year")}`, textSize), y: 265, font: font });
    secondPage.drawText(`${params.get("metric_fov-ncac")}`, { size: textSize, x: 296.5 + (scoreWidth - font.widthOfTextAtSize(`${params.get("metric_fov-ncac")}`, textSize)) * .5, y: 235, font: font });
    secondPage.drawText(`${params.get("score_fov-ncac")}`, { size: textSize, x: 512 + gqWidth - font.widthOfTextAtSize(`${params.get("score_fov-ncac")}`, textSize), y: 235, font: font });
    secondPage.drawText(`${params.get("metric_distchannel")}`, { size: textSize, x: 296.5 + (scoreWidth - font.widthOfTextAtSize(`${params.get("metric_distchannel")}`, textSize)) * .5, y: 204, font: font });
    secondPage.drawText(`${params.get("score_distchannel")}`, { size: textSize, x: 512 + gqWidth - font.widthOfTextAtSize(`${params.get("score_distchannel")}`, textSize), y: 204, font: font });
    secondPage.drawText(`${params.get("metric_orgtraffic")}%`, { size: textSize, x: 296.5 + (scoreWidth - font.widthOfTextAtSize(`${params.get("metric_orgtraffic")}%`, textSize)) * .5, y: 182, font: font });
    secondPage.drawText(`${params.get("score_orgtraffic")}`, { size: textSize, x: 512 + gqWidth - font.widthOfTextAtSize(`${params.get("score_orgtraffic")}`, textSize), y: 182, font: font });
    secondPage.drawText(`${params.get("metric_ltv-ncac-year")}`, { size: textSize, x: 296.5 + (scoreWidth - font.widthOfTextAtSize(`${params.get("metric_ltv-ncac-year")}`, textSize)) * .5, y: 160, font: font });
    secondPage.drawText(`${params.get("score_ltv-ncac-year")}`, { size: textSize, x: 512 + gqWidth - font.widthOfTextAtSize(`${params.get("score_ltv-ncac-year")}`, textSize), y: 160, font: font });
    secondPage.drawText(`${params.get("metric_revpeaks")}`, { size: textSize, x: 296.5 + (scoreWidth - font.widthOfTextAtSize(`${params.get("metric_revpeaks")}`, textSize)) * .5, y: 138, font: font });
    secondPage.drawText(`${params.get("score_revpeaks")}`, { size: textSize, x: 512 + gqWidth - font.widthOfTextAtSize(`${params.get("score_revpeaks")}`, textSize), y: 138, font: font });
    secondPage.drawText(`${params.get("name")} |  ${formattedDate}`, { size: 6, lineHeight: 9, x: 64, y: 36, font: font });

    // Determine the total number of pages in the document
    const totalPageCount = pdfDoc.getPageCount();
    
    // Loop through pages 4 to second-to-last page and add page numbers and footer text
    for (let pageNum = 3; pageNum < totalPageCount - 1; pageNum++) {
      const currentPage = pdfDoc.getPage(pageNum);
      const pageNumber = pageNum + 1;
      
      currentPage.drawText(`${pageNumber}`, { size: 16, x: 36, y: 36, font: oswaldR });
      currentPage.drawText(`${params.get("name")} |  ${formattedDate}`, { size: 6, lineHeight: 9, x: 64, y: 36, font: font });
    }

    // Serialize the modified PDFDocument to bytes (a Uint8Array)
    const pdfBytes = await pdfDoc.save();

    // Trigger the browser to download the modified PDF document
    download(pdfBytes, fileNameBusiness + "_Ecommerce_Diagnostic_Results_" + fileNameDate + ".pdf", "application/pdf");
  }

  // Add an event listener to the button
  $('.modify-pdf-button').on('click', async function () {
    // Add loading spinner class to the <i> element
    $(this).find('.loading-spinner').addClass('spinner');

    try {
      // Generate and modify the PDF
      const pdfBytes = await modifyPdf();

      // Trigger the PDF download
      downloadPdf(pdfBytes);

    } catch (error) {
      console.error('Error generating PDF:', error);
      // Remove loading spinner class in case of error
      $(this).find('.loading-spinner').removeClass('spinner');
    }
  });

  // Function to trigger PDF download
  function downloadPdf(pdfBytes) {
    // Create a blob with the PDF bytes
    const blob = new Blob([pdfBytes], { type: 'application/pdf' });

    // Create a download link and trigger the download
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = `${fileNameBusiness}_Ecommerce_Diagnostic_Results_${fileNameDate}.pdf`;

    // Remove loading spinner class from the <i> element
    $('.modify-pdf-button').find('.loading-spinner').removeClass('spinner').addClass('spinner-complete');
    setTimeout(function () {
      $('.modify-pdf-button').find('.loading-spinner').removeClass('spinner-complete');
    }, 4000)
  }

});
